<template>
  <div class="container py-5">

    <p class="section-subtitle text-center mb-5">
      Les enseignants de l’EITP sont pour la plupart détenteurs de doctorat en sciences sacrées ou en philosophie.
    </p>

    <!-- GRILLE DES PROFESSEURS -->
    <div class="row g-4">
      <div
        class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
        v-for="prof in professeurs"
        :key="prof.id"
      >
        <div class="prof-mini-card">
         <img
                  v-if="prof.user?.urlImage"
                  :src="getImageUrl(prof.user.urlImage)"
                  alt="Photo disciple"
                  class="prof-photo"
                />

                <img
                  v-else
                  :src="defaultPhoto"
                  alt="Photo par défaut"
                  class="prof-photo"
                />
          <h5 class="prof-mini-name">
            <router-link
              :to="`/professeurs/${prof.id}`"
              class="prof-link"
            >
              {{ prof.nom }} {{ prof.prenom }}
            </router-link>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import type { Professeur } from "@/models/Professeur";

export default defineComponent({
  name: "LesProfesseurs",

  setup() {
    const professeurs = ref<Professeur[]>([]);
    const defaultPhoto = "/22.png";

    const getTreeProfesseurs = async () => {
      try {
        const response = await ApiService.get("/professeurs");
        professeurs.value = response.data.data.data;
      } catch (err) {
        console.error(err);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }
    onMounted(getTreeProfesseurs);

    return {
      professeurs,
      defaultPhoto,
      getImageUrl
    };
  },
});
</script>



<style scoped>
.prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;
}

/* MODALE */
.custom-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-modal {
  background: white;
  width: 90%;
  max-width: 900px;
  border-radius: 20px;
  padding: 30px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
}

.modal-header {
  display: flex;
  gap: 20px;
  align-items: center;
}

.modal-photo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #0b1b3f;
}

.grade {
  font-weight: 700;
  color: #6c757d;
}

.spec {
  font-weight: 700;
  color: #ffc107;
}

/* COURS SIMPLES */
.year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

</style>
